export function parseCookies(cookieStr: string): Record<string, string> {
  const cookies: Record<string, string> = {}

  if (!cookieStr) return cookies

  const cookiePairs = cookieStr.split(';').map(pair => pair.trim())

  for (const pair of cookiePairs) {
    const [name, ...rest] = pair.split('=')
    const value = rest.join('=')

    if (name && value) {
      cookies[name.trim()] = value.trim()
    }
  }

  return cookies
}

export function getDomain(headers) {
  const protocol = headers['x-forwarded-proto'] || 'http'
  const host = headers['host']
  return `${protocol}://${host}`
}

function normalizeDomain(hostname: string): string {
  const domain = hostname.split(':')[0]
  return domain.replace(/^www\./, '')
}

export function getAuthHeaders(headers) {
  const cookieString = headers.cookie || ''
  const parsedCookies = parseCookies(cookieString)

  const hostname = headers.host || ''
  const normalizedHost = normalizeDomain(hostname).replace(/\./g, '_')
  const sessionCookieName = `${normalizedHost}_session`

  const sessionCookie = parsedCookies[sessionCookieName]
    ? `${sessionCookieName}=${parsedCookies[sessionCookieName]}`
    : undefined

  const xsrfToken = parsedCookies['XSRF-TOKEN']
  const safarmarketId = parsedCookies['safarmarketId']

  const cookieParts: string[] = []
  if (sessionCookie) cookieParts.push(sessionCookie)
  if (xsrfToken) cookieParts.push(`XSRF-TOKEN=${xsrfToken}`)
  if (safarmarketId) cookieParts.push(`safarmarketId=${safarmarketId}`)
  return {
    xsrfToken: xsrfToken || '',
    cookieHeader: cookieParts?.length ? cookieParts.join('; ') : '',
    origin: getDomain(headers),
    safarmarketId: safarmarketId || '',
  }
}
